export default __webpack_public_path__ + "static/media/weihtage.0457d7b4.png";